/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import CommonHeader from "components/MarketplaceComponents/MarketplaceHeader/CommonHeader";
import { assetImages } from "constants";
import OrderHeader from "../Header/OrderHeader";
import { useTranslation } from "react-i18next";

import SaveOrderPopup from "../Popup/SaveOrderPopup";
import OrderFilterPopup from "../Popup/OrderFilterPopup";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

const OrdersListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [orderList, setOrderList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  // ✅ only one loading control — when to show skeleton
  const [showSkeleton, setShowSkeleton] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [showAllRecords, setShowAllRecords] = useState(false);

  // ✅ CHANGED: null = popup hasn't decided yet (skip API call)
  // []    = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // global search
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all contacts
  const getInvoiceList = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MY_INVOICES +
        `?moduleslug=order`;

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("request url------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response ------>", response);

      if (response.status) {
        setMessageType("success");
        setOrderList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  const getFilteredInvoiceList = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_INVOICES +
        `?moduleslug=order`;

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setOrderList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for remove tag from lead
  const removeTagFromOrder = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_INVOICE;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedInvoiceId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setOrderList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#viewPurchaseOrder"
          aria-controls="viewPurchaseOrder"
          onClick={() => {
            setSelectedInvoiceId(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    { accessorKey: "orderid", header: "Order Id" },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tags.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tags.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedInvoiceId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromOrder([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedInvoiceId &&
                        selectedInvoiceId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedInvoiceIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    { accessorKey: "clientfullname", header: "Customer" },
    { accessorKey: "clientemail", header: "Email" },
    { accessorKey: "invoicedate", header: "Order Date" },
    { accessorKey: "amount", header: "Amount" },
    {
      accessorKey: "itemnames",
      header: "Items",
      size: 300, // Adjust the width as needed
      Cell: ({ row }) => (
        <ul>
          {row.original.invoiceitems.map((item, index) => (
            <li key={index}>
              {item.description} (Qty: {item.unit}, Price: ${item.totalprice})
            </li>
          ))}
        </ul>
      ),
    },
    // { accessorKey: "paymentstatus", header: "Payment Status" },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [orderList, i18n.language, selectedTagId],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  const resetFilterData = () => {
    setRowSelection({});
    setSelectedInvoiceIds([]);
    setJsonFilterQuery(null);
    setLastPagination({ pageIndex: 0, pageSize: 10 });

    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setIsFilterReset(true);
    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  // ✅ CHANGED: Single API trigger — fires only after popup has decided.
  // null guard prevents API call before popup responds.
  // withSkeleton=true — filter apply always shows skeleton.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery?.length > 0) {
      getFilteredInvoiceList(debouncedSearch, true); // withSkeleton=true
    } else {
      getInvoiceList(debouncedSearch, true); // withSkeleton=true
    }
  }, [jsonFilterQuery]);

  // ✅ CHANGED: Search effect — no skeleton (table stays visible).
  // isDataReady guard prevents running before initial load finishes.
  // Priority: showAllRecords > jsonFilterQuery > default
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load

    if (jsonFilterQuery?.length > 0) {
      getFilteredInvoiceList(debouncedSearch, false); // withSkeleton=false
    } else {
      getInvoiceList(debouncedSearch, false); // withSkeleton=false
    }
  }, [debouncedSearch]);

  // ✅ reload happened — always show skeleton
  useEffect(() => {
    if (reloadData) {
      getInvoiceList("", true); // withSkeleton=true
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedInvoiceIds(selectedIdsArray);
    } else {
      setSelectedInvoiceIds([]);
    }
  }, [rowSelection]);

  // ✅ Debounce — after typing 600ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  // useEffect  for save last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const downloadAsExcel = () => {
    if (orderList.length > 0) {
      // Define headers
      const headers = [
        t("Order Id"),
        t("Customer"),
        t("Email"),
        t("Order Date"),
        t("Amount"),
        t("Items"),
      ];

      // Filter data based on selection
      const filteredList =
        selectedInvoiceIds.length > 0
          ? orderList.filter((item) => selectedInvoiceIds.includes(item._id))
          : orderList;

      // Map data to rows
      const data = filteredList.map((item) => [
        item.orderid || "",
        item.clientfullname || "",
        item.clientemail || "",
        item.invoicedate || "",
        item.amount || "",
        item.invoiceitems.map((item) => item.description).join(", "),
      ]);

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Orders"));

      // Write to buffer and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Orders")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_MARKETPLACE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          <CommonHeader activeOption="Orders" />

          <div className="container-fluid px-lg-5">
            {/* header */}
            <OrderHeader
              reloadList={refreshRecords}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedInvoiceIds={selectedInvoiceIds}
              downloadAsExcel={downloadAsExcel}
            />

            {/* table */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={orderList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination} // set pagination
                  autoResetPageIndex={false}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
          </div>

          {/* ----- all pop up render here ----- */}

          {/* ------ add label modal render here ----- */}

          <SaveOrderPopup
            selectedInvoiceId={selectedInvoiceId}
            setSelectedInvoiceId={setSelectedInvoiceId}
          />

          <AddLabelModal
            moduleName="invoice"
            selectedIds={selectedInvoiceIds}
            afterTagModalClose={afterModalActionClose}
            onModalClose={() => {
              setSelectedInvoiceIds([]);
              setRowSelection({});
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <OrderFilterPopup
            moduleSlug="productorderlist"
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            setColumnOrder={setColumnOrder}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            visibleColoumns={visibleColoumns}
            columns={columns}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default OrdersListBody;
